import { ActionType } from "../action-types/index";
import { Action } from "../actions";
interface Store {
  id: number;
  name: { [key: string]: string }; // Assuming name can be in multiple languages
  slug: string;
  // ... other properties for a store
}

interface Discount {
  id: number;
  amount: string;
  percent: string;
  max: string;
  limit: string;
  // ... other properties for a discount
}

export interface qrCode {
  id: number;
  code: string;
  claimed: boolean | null;
}
export interface OrderEventTable {
  id: number;
  name: string;
  slug: string;
  stores: Store[];
  discount: Discount;
  // ... other properties for order_event_table
}

interface apiState {
  orderEventTable: OrderEventTable | null;
  qrCode: qrCode | null;
  shareQrcodePopup: boolean;
  shareQrcode: string;
  qrInd: number | 0;
  userInfo: any;
  loggedIn: any;
  token: string;
  storeId: number | null;
  storeInfo: any;
  bookingDetails: any;
  extrasFields:any;
  slotsList:any
}

const initialState = {
  orderEventTable: null,
  qrCode: null,
  shareQrcodePopup: false,
  shareQrcode: "",
  qrInd: 0,
  userInfo: {},
  loggedIn: false,
  token: "",
  storeId: null,
  storeInfo: null,
  bookingDetails: [],
  extrasFields:[],
  slotsList: []

};

const apiReducer = (state: apiState = initialState, action: Action) => {
  switch (action.type) {
    // Handle actions here if needed
    case ActionType.SET_ORDER_EVENT_TABLE:
      return { ...state, orderEventTable: action.payload };

    case ActionType.SET_QR_CODE:
      return { ...state, qrCode: action.payload };

    case ActionType.SET_SHARE_QR_CODE:
      return {
        ...state,
        shareQrcodePopup:
          action.shareQrcodePopup != null || undefined
            ? action.shareQrcodePopup
            : state.shareQrcodePopup,
        shareQrcode:
          action.shareQrcode != null || undefined
            ? action.shareQrcode
            : state.shareQrcode,
      };
    case ActionType.SET_QR_INDEX:
      return { ...state, qrInd: action.payload };
    case ActionType.SET_USER_INFO:
      return { ...state, userInfo: action.payload };
    case ActionType.SET_LOGGED_IN:
      return { ...state, loggedIn: action.payload, token: action.token };

    case ActionType.SET_STORE_MANAGER_LIST:
      return { ...state, storeManagerList: action.payload };

    case ActionType.SET_STORE_ID:
      return { ...state, storeId: action.payload };

    case ActionType.SET_STORE_INFO:
      return { ...state, storeInfo: action.payload };

      case ActionType.SET_BOOKING_DETAILS:
      return {...state, bookingDetails: action.payload}
      case ActionType.SET_EXTRAS_FIELDS:
        return {...state, extrasFields: action.payload}
      case ActionType.SET_SLOTS_LIST:
        return {...state, slotsList: action.payload}
    default:
      return state;
  }
};

export default apiReducer;
